/**
 * Generated bundle index. Do not edit.
 */
export { CdkAccordion, MatAccordion, AccordionItem, MatExpansionPanel, MatExpansionPanelActionRow, MatExpansionPanelHeader, MatExpansionPanelDescription, MatExpansionPanelTitle, MatExpansionModule } from './public-api';
export { EXPANSION_PANEL_ANIMATION_TIMING as ɵc18, MatExpansionPanelBase as ɵa18, _MatExpansionPanelMixinBase as ɵb18 } from './expansion-panel';
//# sourceMappingURL=index.js.map